import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { to: "/wizard", label: "カメラ診断" },
  { to: "/brands", label: "取り扱い商品" },
  { to: "/#flow", label: "ご利用の流れ" },
  { to: "/contact", label: "お問い合わせ" },
  { to: "/about", label: "当社について" },
];

const Footer = () => (
  <footer className="border-t border-line bg-fill text-[13px] text-ink-2">
    <div className="mx-auto max-w-6xl px-4 py-10 md:px-8">
      <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
        <Link to="/" className="inline-flex min-h-11 items-center" aria-label="CAMARAGO トップへ">
          <img src="/images/camarago_wordmark.png" alt="CAMARAGO" className="h-4 w-auto opacity-80" />
        </Link>
        <nav aria-label="フッターメニュー" className="grid grid-cols-2 gap-x-10 gap-y-1 md:flex md:gap-8">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="flex min-h-11 items-center hover:text-ink">
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="mt-6 border-t border-line pt-6">
        運営：株式会社 GLANMA　©︎ {new Date().getFullYear()} CAMARAGO
      </div>
    </div>
  </footer>
);

export default Footer;
